import {
    POST_ORDER_INFO,
    CHANGE_RECIPIENT_MEMBER,
    EDITMESSAGEARRAY,
    EDITRECIPIENTSTATUS,
    EDIT_SERVICE_MESSAGE_ARRAY
} from '../mutationTypes'
import {
    postCreatOrder
} from '@/models/confirmOrder'
const state = {
    order: {},
    recipientType: true,
    isKeepStatusForAddress: false,
    messageArray: [],
    serviceMessageArray: []
}
const mutations = {
    [POST_ORDER_INFO] (state, data) {
        state.order = data
    },
    [CHANGE_RECIPIENT_MEMBER] (state, type) {
        state.recipientType = type
    },
    [EDITMESSAGEARRAY] (state, data) {
        state.messageArray = data
    },
    [EDIT_SERVICE_MESSAGE_ARRAY] (state, data) {
        state.serviceMessageArray = data
    },
    [EDITRECIPIENTSTATUS] (state, data) {
        state.isKeepStatusForAddress = data
    }
}

export const actions = {
    async postOrderInfo ({
        commit
    }, data) {
        let back = await postCreatOrder(data)
        commit(POST_ORDER_INFO, back)
    },
    changeRecipientMember ({
        commit
    }, type) {
        commit(CHANGE_RECIPIENT_MEMBER, type === 'store')
    },
    editMessageArray ({
        commit
    }, data) {
        commit(EDITMESSAGEARRAY, data)
    },
    editServiceMessageArray ({
        commit
    }, data) {
        commit(EDIT_SERVICE_MESSAGE_ARRAY, data)
    },
    editRecipientStatus ({
        commit
    }, type) {
        commit(EDITRECIPIENTSTATUS, type)
    }
}

export const getters = {}

export default {
    state,
    mutations
}
